import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryCards() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section header */}
        <div className="text-center mb-10">
          <h3 className="text-sm font-semibold text-accent-500 uppercase tracking-wider mb-2">
            <i className="ri-grid-line mr-1.5"></i>
            分类浏览
          </h3>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            海量片库 · 随心选择
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-lg mx-auto">
            涵盖电影、电视剧、综艺、动漫四大板块，满足你的一切观影需求
          </p>
        </div>

        {/* Category cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.link}
              className="group relative rounded-xl overflow-hidden cursor-pointer h-56 md:h-64"
            >
              {/* Background image */}
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/90">
                    <i className={`${cat.icon} text-background-50 text-base`}></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-white">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-sm text-white/70 mb-2">{cat.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-white/50">{cat.count} 部资源</span>
                  <span className="text-xs text-primary-400 group-hover:translate-x-1 transition-transform duration-200 whitespace-nowrap">
                    立即浏览 <i className="ri-arrow-right-line ml-0.5"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}